import { useEffect } from 'react';
import useApi from './useApi';
import { VesselBM } from '../types/BusinessModel/Vessel/VesselBM';
import { VesselFactory } from '../factory/Vessel/VesselFactory';
import { useVesselStore } from '../context/VesselContext';
import useApiEndpoints from '../context/useApiEndpoints';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { state, getApiData } = useApi();
    const { setVesselList, setFilteredVesselList, setIsVesselListRetrieved } = useVesselStore();
    const vesselFactory = new VesselFactory();

    const getVessels = () => {
        getApiData({
            endpoint: apiEndpoints['getVessels'].url,
        });
    };

    useEffect(() => {
        if (state.status === 'success') {
            const vessels = state.result as VesselBM[];
            const vesselList = vesselFactory.getVessels(vessels);
            setVesselList(vesselList);
            setFilteredVesselList(vesselList.filter((v) => v.isActive));
            setIsVesselListRetrieved(true);
        } else {
            processApiEndpointError(state);
        }
    }, [state]);

    return { state, getVessels };
};
